import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
var Table = /*#__PURE__*/_createClass(function Table() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, Table);
  this.type = options.type || 'table';
  var rowCount = options.rowCount,
    columnCount = options.columnCount;
  var children = options.children;
  if (rowCount) {
    var list = new Array(rowCount).fill('');
    children = list.map(function () {
      return generateTableRow({
        columnCount: columnCount
      });
    });
  }
  this.children = children;
});
var TableRow = /*#__PURE__*/_createClass(function TableRow() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, TableRow);
  this.type = options.type || 'table_row';
  var columnCount = options.columnCount;
  var children = options.children;
  if (columnCount) {
    var list = new Array(columnCount).fill('');
    children = list.map(function () {
      return generateTableCell();
    });
  }
  this.children = children;
});
var TableCell = /*#__PURE__*/_createClass(function TableCell() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, TableCell);
  this.type = options.type || 'table_cell';
  this.children = options.children || [{
    type: 'paragraph',
    children: [{
      text: ''
    }]
  }];
  this.data = options.data || {
    align: 'left'
  };
});
var generateTable = function generateTable(options) {
  return Object.assign({}, new Table(options));
};
var generateTableRow = function generateTableRow(options) {
  return Object.assign({}, new TableRow(options));
};
var generateTableCell = function generateTableCell(options) {
  return Object.assign({}, new TableCell(options));
};
export { generateTable, generateTableRow, generateTableCell };